import React, { Component } from "react";
import { Modal } from "react-bootstrap";

export default class JewCertNotesDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      res: this.props.res,
    };
    this.onModalHide = this.onModalHide.bind(this);
  }

  onModalHide() {
    let { hide } = this.props;
    this.setState(() => {
      hide && hide();
    });
  }

  render() {
    let { show, res } = this.props;
  
    const jewCertNotes = res?.JewCertNotes || "";

    // Split by newlines, trim, and remove empty lines
    const noteLines = jewCertNotes
      .split("\n")
      .map(line => line.trim())
      .filter(line => line.length > 0);

    return (
      <Modal
        show={show}
        onHide={() => this.onModalHide()}
        animation={false}
        dialogClassName="show-more_modal-dailog"
        className="more-details-modal"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Jewelry Cert Notes:
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="item__description__box" style={{
            height: '40vh',
            overflow: 'auto'
          }} >
            {noteLines.map((note, index) => (
              <div key={index}>
                <p>{note}</p>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}